import multicall from './multicall'
import uniswapV2Router2 from './uniswap-v2-router2'

export default {
  multicall,
  uniswapV2Router2
}
